import { Link } from "react-router-dom";
import { renderCustomColumnDefs } from "../../../shared/Table/table.utils";
import { formatDate, renderAddress } from "../../../utils";
import { manifestMileageOptions } from "../../../constants/select";
import MileageSelector from "./MileageSelector";
import { Bars2Icon } from "@heroicons/react/24/outline";

// Config for table and form
const tableConfig = [
  {
    id: "drag",
    header: "",
    width: 40,
    // Fallback rendering; the actual drag handle is attached by the Table RowComponent
    cell: () => (
      <div className="flex items-center justify-center text-gray-400">
        <Bars2Icon className="h-4 w-4" />
      </div>
    ),
    disableSortBy: true,
    disableFilters: true,
  },
  {
    header: "#",
    id: "rowNumber",
    cell: (ctx) => ctx.row.index + 1,
    disableSortBy: true,
    disableFilters: true,
    width: 50,
  },
  {
    header: "Job Load #",
    id: "job",
    minWidth: 120,
    accessorFn: (row) => row.jobId?._id,
    cell: ({ row: { original }, getValue }) => {
      const value = getValue();
      return (
        <Link
          className="text-primary-600 hover:underline"
          to={`/jobs/${original.jobId?._id}`}
        >
          {original.jobId?.loadNumber}
        </Link>
      );
    },
  },
  {
    id: "appointmentDate",
    header: "Pickup Date",
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) {
        return null;
      }
      const localDate = new Date(value);
      if (isNaN(localDate.getTime())) {
        return null;
      }
      return formatDate(localDate, null, true);
    },
    width: 120,
  },
  {
    id: "orderNumber",
    visible: true,
    cell: ({ row: { original }, getValue }) => {
      return (
        <Link
          className="text-primary-600 hover:underline"
          to={`/jobs/${original.jobId?._id}`}
        >
          {getValue()}
        </Link>
      );
    },
  },
  {
    Header: "Pickup Location",
    accessorFn: (row) => row.route?.origin,
    cell: ({ getValue }) => renderAddress(getValue()),
    width: 100,
  },
  {
    Header: "Dropoff Location",
    accessorFn: (row) => row.route?.destination,
    cell: ({ getValue }) => renderAddress(getValue()),
    width: 100,
  },
  // {
  //   id: "loadType",
  //   accessorKey: "loadType",
  //   width: 120,
  //   cell: ({ getValue }) => getValue(),
  // },

  {
    header: "Standby Hours",
    id: "waitTime",
    visible: true,
    required: true,
    cell: ({ getValue }) => getValue()?.total,
  },
  // { id: "driver", minWidth: 100, cell: ({ getValue }) => getValue()?.fullName },
  {
    id: "route",
    header: "Total Miles",
    minWidth: 200,
    editable: {
      type: "custom",
      layout: MileageSelector,
      disabled: ({ original }) => !original.payoutId,
      editWidth: 350,
    },
    cell: ({ getValue, row }) => {
      const value = getValue();
      const route = row.original.route;

      // If using custom manifest mileage, show that
      if (
        row.original.useCustomManifestMileage &&
        row.original.customManifestMileage != null
      ) {
        return <div>{row.original.customManifestMileage} mi</div>;
      }

      // Otherwise show route mileage
      if (route) {
        const mileage = route.mileage || route.defaultMileage || 0;
        return <div>{mileage} mi</div>;
      }

      return <div>0 mi</div>;
    },
  },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);
